import { makeStyles } from '@mui/styles';
const darkGray = '#263238';
export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTable-root': {
      border: 'solid 1px rgba(109, 114, 120, 0.18)',
      borderRadius: 4,
    },
    '& .MuiTableRow-head th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& .MuiTableRow-head th:last-child': {
      borderTopRightRadius: 4,
      width: 145,
    },
    '& .MuiIconButton-root': {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color:'#2b3990',
    '&:hover':{
      background:'#2b3990',
      color: '#fff'
    }
  },
  props: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
  },
  tickIcon: {
    color: '#43A047',
    fontSize: 17,
  },
  tickItem: {
    marginBottom: theme.spacing(1),
  },
  propsTitle: {
    color: '#2b3940',
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: theme.spacing(1.5),
  },
  tickText: {
    fontSize: 12,
    fontWeight: 'normal',
    marginInlineStart: theme.spacing(1),
    color: '#2b3940',
  },
  otherActions: {
    marginLeft: 'auto !important',
    marginRight: 'o !important',
  },
  otherActionsMenu: {
    border: '1px solid #d8d1d1',
    '& .MuiButtonBase-root.Mui-disabled': {
      pointerEvents: 'auto !important',
    },
  },
  otherActionsMenuItem: {
    padding: theme.spacing(1.5),
    color: darkGray,
    minWidth: 160,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  generatedApiKey: {
    background: theme.palette.grey[200],
    padding: theme.spacing(1, 2),
    paddingInlineStart: theme.spacing(1),
    borderRadius: 4,
    textAlign: 'center',
    fontSize: 15,
    marginTop: theme.spacing(2),
    '& b': {
      fontFamily: 'Vazir',
    },
  },
  copyIcon: {
    width: 20,
    height: 20,
    marginInlineEnd: theme.spacing(1),
    marginTop: -2,
  },
  cardHeaderButton: {
    [theme.breakpoints.down('sm')]: {
      marginRight: 'auto',
      marginTop: theme.spacing(2),
    },
  },
}));
